var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00195312H513V341.991H0V-0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 341.991V-0.00195312L280.967 175.089H87.7811L271.716 341.991H0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.247 164.871L10.2188 18.4072V331.772H245.247L61.3123 164.871H245.247Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1946 239.561L83.5771 232.685L91.3623 218.527L75.4873 221.563L73.4754 205.527L62.4189 217.322L51.3613 205.527L49.3494 221.563L33.4754 218.526L41.2606 232.685L26.6411 239.561L41.2606 246.436L33.4754 260.594L49.3504 257.559L51.3613 273.594L62.4189 261.799L73.4754 273.594L75.4873 257.559L91.3613 260.595L83.5771 246.437L98.1946 239.561ZM88.4406 106.531L77.8078 101.53L83.4699 91.2318L71.9244 93.4411L70.4605 81.7773L62.4189 90.3551L54.3772 81.7773L52.9143 93.4411L41.3668 91.2318L47.0299 101.53L36.3961 106.531L62.4189 111.735L88.4406 106.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6446 106.531C93.6446 123.776 79.6644 137.757 62.4187 137.757C45.1731 137.757 31.1929 123.776 31.1929 106.531",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/NP.ffbb41fbc74789c7a295f99e079c7952.svg";
export { ForwardRef as ReactComponent };